// 'Gill Sans MT' added to front of list for bug fix (see DP-3975)
export const CHART_FONT_FAMILY =
  "'Gill Sans MT', 'Gill Sans', 'Seravek', 'Trebuchet MS', sans-serif";
